<template>
  <q-dialog v-model="shown">
    <q-card style="min-width: 50%;">
      <q-card-section class="row items-center q-mx-xs">
        <div class="text-h6">
          Swap Items
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section>
        <model-table
          :collection="order.orderItems"
          selection="multiple"
          :columns="[
            { field: 'id' },
            { field: 'type', component: OrderItemTypeCell },
            { field: 'state', component: OrderStateCell },
            { field: 'description', maxWidth: '250px' },
            { field: 'price', component: 'money' },
            { field: 'cannotVoidReason' },
          ]"
          :filter-by-data-array="order.swappableOrderItems"
          :cell-class="props => classesForRow(props.row)"
          :show-add="false"
          :show-edit="false"
          row-key="id"
          :initial-selection="selected"
          @selected-input="selectedUpdate => selected = selectedUpdate"
        />
      </q-card-section>
      <q-card-actions class="row q-gutter-sm justify-end q-ma-sm items-start  ">
        <q-space />
        <q-toggle
          v-if="$register && currentSite.anonymousOrderRequirements.allow_phone_orders"
          v-model="order.phoneOrder"
          class="q-mr-md"
          keep-color
          :disable="order.invoicedOrder"
          :color="order.phoneOrder ? 'green' : 'grey'"
          unchecked-icon="phone"
          checked-icon="phone"
          label="Phone Order"
          @click.stop
        />
        <q-btn
          color="primary"
          :loading="startingSwap"
          :disable="validSelection.length === 0"
          @click="startSwap"
        >
          Start Swap
        </q-btn>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>

import ModelTable from 'src/modules/admin/components/ModelTable'
import OrderItemTypeCell from 'src/modules/admin/order/components/OrderItemTypeCell'
import OrderStateCell from 'src/modules/admin/order/components/OrderStateCell'

export default {
  name: 'RefundDialog',
  components: {
    ModelTable
  },
  props: {
    modelValue: {
      type: Boolean,
      required: false
    },
    order: {
      type: Object,
      required: true
    }
  },
  emits: ['update:model-value', 'next'],
  data () {
    return {
      shown: false,
      selected: [],
      startingSwap: false
    }
  },
  configuration: ['currentCircuit', 'currentSite'],
  computed: {
    validSelection () {
      return _.filter(this.selected, { placed: true, canVoid: true })
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
      this.selected = [..._.filter(this.order.orderItems.data, { placed: true, type: 'ticket' })]
    }
  },
  created () {
    this.OrderItemTypeCell = OrderItemTypeCell
    this.OrderStateCell = OrderStateCell
  },
  methods: {
    show () {
      this.shown = true
    },
    async startSwap () {
      this.startingSwap = true
      const success = await this.order.void(_.map(this.validSelection, 'id'), _.filter(this.refundOptions, option => option.amount !== 0), null, true)
      this.startingSwap = false

      if (!success) return

      this.shown = false

      this.$emit('next', this.order)
    },
    classesForRow (orderItem) {
      if (orderItem.state === 'placed' || orderItem.state === 'paid') {
        return []
      } else if (orderItem.state === 'voided') {
        return ['tr-bg-grey-5', 'bg-grey-5']
      } else if (orderItem.state === 'draft') {
        return ['tr-bg-grey-4', 'bg-grey-4']
      } else {
        throw new Error('Unhandled Condition')
      }
    }
  }
}

</script>

<style lang="scss" scoped>
:deep(.tr-bg-grey-4) {
  background: #DDD;
}
</style>
